import * as S from "./List.style";

interface ListProps {
  overflowX?: boolean;
  direction?: "row" | "column";
  gridColumns?: string;
  gap?: number | string;
  children?: React.ReactNode;
  left?: string;
}

export const List = ({
  overflowX = false,
  direction = "row",
  gridColumns,
  gap,
  children,
  left = "-16px",
}: ListProps) => {
  return (
    <S.List
      $overflowX={overflowX}
      $direction={direction}
      $gridColumns={gridColumns}
      $gap={gap}
      $left={left}
    >
      {children}
    </S.List>
  );
};
